import type { ReceiptTemplate } from '../schema';

export const zaxbysTemplate: ReceiptTemplate = {
  id: 'zaxbys',
  name: "Zaxby's Receipt",
  brand: "ZAXBY'S",
  description: "Zaxby's chicken restaurant receipt",
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'zaxbys-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/zaxbys.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, GA 30301',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zaxbys-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 12:30 PM\nORDER #847',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'zaxbys-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'WINGS & THINGS MEAL', quantity: '1', price: '12.99', sku: '' },
          { id: '2', name: 'CRINKLE FRIES', quantity: '1', price: '0.00', sku: '' },
          { id: '3', name: 'TEXAS TOAST', quantity: '1', price: '0.00', sku: '' },
          { id: '4', name: 'DRINK MED', quantity: '1', price: '2.49', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zaxbys-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '15.48', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.24', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '16.72', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zaxbys-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zaxbys-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'INDESCRIBABLY GOOD!\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

